import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { CommonPatientCard, CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents';
import Loader from '../../../../Components/Loader';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { getCachevalue } from '../../../../Utility/Services/CacheProviderService';
import { Colors } from '../../../../Styles/Colors';
import { Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography, Tooltip, } from '@mui/material';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { formatDateAndTimeMeth2 } from '../../../../Components/CommonFunctions/CommonFunctions';
import { CurrencySymbol } from '../../../../Utility/Constants'
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { AmountFormat } from '../../../../Components/CommonFunctions/CommonFunctions';

const CancelledOrder = ({ opOrder, fromWalkIn = false }) => {
    const [formState, setformState] = useState({
        PatientData: {},
        CancelledOrder: [],
    })
    const [isLoader, setIsLoader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [amtState, setamtState] = useState([]);
    const [insuToolOpen, setInsuToolOpen] = useState(false);       

    useEffect(() => {
        const patientData = opOrder ? getCachevalue("patientData") : getCachevalue("IppatientData");

        if (patientData) {
            const parsedData = JSON.parse(patientData);
            setformState(prev => ({
                ...prev,
                PatientData: parsedData
            }));

            if (parsedData?.appointment_id || parsedData?.id) {
                getOrderListData(parsedData);
                getOrderCardAmt(parsedData);
            }
        }
        // Hide tooltip after 2 seconds
        const hideTooltip = setTimeout(() => {
            setInsuToolOpen(false);
        }, 2000);

        return () => {
            clearTimeout(hideTooltip);
        };
    }, []);

    const getOrderListData = (PatientData) => {
        try {
            if (!PatientData?.appointment_id && !PatientData?.id) return;

            const isAppointment = !!PatientData?.appointment_id;
            const apiUrl = isAppointment ? Serviceurls.BILLING_ORDER_LIST : fromWalkIn ? Serviceurls.AYURVEDA_WALKIN_ORDER_VIEW : Serviceurls.BILLING_ORDER_LIST_IP;
            const queryParam = isAppointment ? `appointment_id=${PatientData?.appointment_id}` : fromWalkIn ? `walkin_admission_id=${PatientData?.id}` : `ip_admission_id=${PatientData?.id}`;
            RestAPIService.getAll(`${apiUrl}?${queryParam}&get_type=${'list'}&order_status=${'Cancelled'}&service_id=`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const CancelledData = response.data.data || [];
                        setformState((prevState) => ({
                            ...prevState,
                            CancelledOrder: CancelledData,
                        }));
                    setInsuToolOpen(true);
                    }
                }).catch((error) => {
                    setInsuToolOpen(true);
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setInsuToolOpen(true);
            errorMessage(error.message)
        }
    }

    const getOrderCardAmt = (PatientData) => {
        try {
            RestAPIService.getAll(Serviceurls.NEW_BILLING_ORDER_DEPTWISE + `?order_type=${opOrder ? "op" : fromWalkIn ? "Walkin" : "ip"}&${opOrder ? `appointment_id=${PatientData?.appointment_id}` : fromWalkIn ? `walkin_admission_id=${PatientData?.id}` : `admission_id=${PatientData?.id}`}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const AmtValues = Object.entries(response?.data?.data)?.map(([key, value]) => ({
                            module: key,
                            amount: value
                        }));
                        setamtState(AmtValues)
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    };

    const errorMessage = (msg) => {
        seterrorMsgText(msg);
        seterrorMsg(true);
    };

    const renderTable = () => {
        try {
            return (
                <Box sx={{ height: "60vh", width: "100%", mt: "0.35vw" }}>
                    <TableContainer sx={{ height: '60dvh', overflow: 'auto', border: '1px solid lightgray' }}>
                        <Table stickyHeader>
                            <TableHead size="small" sx={{ "& .MuiTableCell-root": { padding: "0.25rem" } }}>
                                <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                                    <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>S.No</TableCell>
                                    <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Service ID</TableCell>
                                    <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Cancelled Date & Time</TableCell>
                                    <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Cancelled By</TableCell>
                                    <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Service Description</TableCell>
                                    <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Module</TableCell>
                                    <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Unit</TableCell>
                                    <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Created Details</TableCell>
                                    <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7' }}>Remarks</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody size="small" sx={{ "& .MuiTableCell-root": { padding: "0px" } }}>
                                {formState?.CancelledOrder?.length > 0 ? formState.CancelledOrder.map((order, index) => (
                                    <TableRow key={index}>
                                        <TableCell style={{ fontSize: '0.9rem', paddingLeft: "0.65vw" }}>{index + 1}</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem' }}>
                                            {order?.order_item_number ? (
                                                // sliced based on the first slash
                                                <Tooltip title={order.order_item_number} arrow>
                                                    <Typography>
                                                        {order.order_item_number.includes('/')
                                                            ? `...${order.order_item_number.slice(order.order_item_number.indexOf('/'))}`
                                                            : order.order_item_number}
                                                    </Typography>
                                                </Tooltip>
                                            ) : (
                                                '-'
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem' }}>{order.modified_date ? formatDateAndTimeMeth2(order.modified_date) : '-'}</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem' }}>{order.modified_by || '-'}</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem' }}>
                                            <Box component={'div'}>{order?.service_head_name && order?.service_name ?
                                                <Box>
                                                    <Box sx={{ display: 'flex' }}>
                                                        {/* tool tip funtionality */}
                                                        {order?.service_head_name?.length > 15 ? (
                                                            <Tooltip title={order?.service_head_name} arrow>
                                                                <Typography fontWeight={600} fontSize={'0.8vw'}>
                                                                    {`${order?.service_head_name.slice(0, 15)}...`}
                                                                </Typography>
                                                            </Tooltip>
                                                        ) : (
                                                            <Typography fontWeight={600} fontSize={'0.8vw'}>
                                                                {order?.service_head_name}
                                                            </Typography>
                                                        )}
                                                        {order?.packagename ? order?.packagename?.length > 25 ? (
                                                            <Tooltip title={order?.packagename} arrow>
                                                                <Typography marginLeft={"0.5vw"} fontWeight={600} fontSize={'0.8vw'}>
                                                                    {`( ${order?.packagename.slice(0, 20)}... )`}
                                                                </Typography>
                                                            </Tooltip>
                                                        ) : (
                                                            <Typography marginLeft={"0.5vw"} fontWeight={600} fontSize={'0.8vw'}>
                                                                {`( ${order?.packagename} )`}
                                                            </Typography>
                                                        ) : null}
                                                    </Box>
                                                    <Box display={'flex'}>
                                                        {order?.service_name?.length > 15 ? (
                                                            <Tooltip
                                                                title={`${order?.service_code ? order?.service_code : (order?.service_head_code) ? order?.service_head_code : '-'} | ${order?.service_name}`}
                                                                arrow
                                                            >
                                                                <Typography fontSize={'0.8vw'}>
                                                                    {`${order?.service_code ? order?.service_code : (order?.service_head_code) ? order?.service_head_code : '-'} | ${order?.service_name.slice(0, 15)}...`}
                                                                </Typography>
                                                            </Tooltip>
                                                        ) : (
                                                            <Typography fontSize={'0.8vw'}>
                                                                {`${order?.service_code ? order?.service_code : (order?.service_head_code) ? order?.service_head_code : '-'} | ${order?.service_name}`}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>
                                                : "-"}
                                            </Box>
                                        </TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem' }}>{(order?.module_type === 'IP_OP' ? 'IP & OP' : order?.module_type) || '-'}</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem' }}>{(order?.unit_type === 'Hrs' ? ((order?.unit?.split(':').slice(0, 2).join(':')) || '-') : (order?.unit || '-')) || '-'}</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem' }}>{
                                            <Box component={'div'}>{order?.created_by ?
                                                <Tooltip placement='top' title={order?.created_by} arrow>
                                                    <Box>
                                                        <Typography fontWeight={600} fontSize={'0.8vw'}>{order?.created_by}</Typography>
                                                        <Box display={'flex'}>
                                                            <Typography fontSize={'0.8vw'}>{order?.created_date ? formatDateAndTimeMeth2(order?.created_date) : '-'}</Typography>
                                                        </Box>
                                                    </Box>
                                                </Tooltip> : "-"}
                                            </Box>
                                        }</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem' }}>{order.cancel_reason && order.cancel_reason?.length > 25 ?
                                            <Tooltip placement="top" title={order.cancel_reason} arrow>
                                                <div>{order.cancel_reason?.slice(0, 25) + "..."}</div>
                                            </Tooltip>
                                            : order?.cancel_reason ? order?.cancel_reason : "-"}
                                        </TableCell>
                                    </TableRow>
                                )) : <TableRow>
                                    <TableCell colSpan={9} align='center'
                                        sx={{ borderBottom: 'none', position: 'relative', top: '10rem' }}
                                    >No Records To Be Shown</TableCell>
                                </TableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            );
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const MemoizedPatientDetails = React.memo(
        ({ data, showDetailed, forceOpen }) => (
            <CommonPatientDetails
                data={data}
                showDetailed={showDetailed}
                forceOpen = {forceOpen}
            />
        ),
        (prevProps, nextProps) => {
            return (JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data)
                && prevProps.forceOpen === nextProps.forceOpen)
        }
    );

    const CommonPatientSection = React.memo(({ PatientData, insuToolOpen }) => {
        const attender = useMemo(() => ({
            lineOne: "AttenderName",
            lineTwo: PatientData?.attender_name || "-",
            lineFour: "ContactNumber",
            lineFive: PatientData?.attender_mobile || "-",
        }), [PatientData?.attender_name, PatientData?.attender_mobile]);

        const createOrderAmtCard = useCallback((label, amount) => ({
            image: ImagePaths.OrderIcon.default,
            height: "1.3vw",
            width: "1.3vw",
            lineOne: label,
            lineTwo: amount ? AmountFormat(amount) : `${CurrencySymbol} 0.00`,
        }), []);

        return (
            <Box display={'flex'} alignItems='center'>
                <Box className="eMed_Patient_Details_Long eMed_patient_box">
                    <MemoizedPatientDetails data={PatientData} showDetailed={true} forceOpen={insuToolOpen}/>
                </Box>
                {PatientData?.appointment_id ? null : <CommonPatientCard details={attender} showDetailed={true} />}
                <Box sx={{ display: 'flex', width: opOrder ? "56dvw" : "43.7dvw", alignItems: 'center', overflow: 'auto' }}>
                    {
                    amtState?.map((item, index) => (
                        <CommonPatientCard key={index} details={createOrderAmtCard((item?.module), item?.amount)} smallWidth={true} />
                    ))
                    }
                </Box>
            </Box>
        );
    }, (prevProps, nextProps) => {
        return prevProps.PatientData === nextProps.PatientData && 
            prevProps.insuToolOpen === nextProps.insuToolOpen;
    });

    return (
        <Box sx={{ backgroundColor: Colors.ComponentBgColor, height: "74vh" }}>
            <Box component={"div"} marginLeft={"0.5vw"} className="eMed_patient_header">
                <Box display={"flex"} alignItems="center">
                    <CommonPatientSection PatientData={formState?.PatientData} insuToolOpen={insuToolOpen}/>
                </Box>
            </Box>
            <Box sx={{ backgroundColor: "white", margin: "1vw 0.5vw", padding: "0.5vw", height: '65dvh' }}>
                <Box>{renderTable()}</Box>
            </Box>
            <Loader loaderOpen={isLoader} />
            {errorMsg && <ToastMsg severity={'error'} msg={errorMsgText} msgPop={msgClose} />}
            {successMsg && <ToastMsg severity={'success'} msg={successMsgText} msgPop={msgClose} />}
        </Box>
    );
};

export default CancelledOrder;